import {Component} from '@angular/core';
import {ListViewItem} from "@domain/common/list-view/list-view-item";
import {ZoneUtilisateur} from "@domain/zone-utilisateur/zone-utilisateur";
import {ToastrService} from "ngx-toastr";
import {TranslateService} from "@ngx-translate/core";
import {ConfirmService} from "@share/component/confirmation/confirm.service";
import {PrestationService} from "@services/admin/frais/prestation.service";
import {filter, first} from "rxjs/operators";
import {TypeCodeErreur} from "@domain/common/http/result";
import {MatLegacyDialog as MatDialog} from "@angular/material/legacy-dialog";
import {AddZuComponent} from "@components/admin/frais/prestations/prestation-detail/zu/add-zu.component";

/**
 * Composant d'un item de la liste des zones paramétrables
 */
@Component({
	host: {'data-test-id': 'zu-list-item'},
	templateUrl: './zu-list-item.component.html'
})
export class ZuListItemComponent extends ListViewItem<ZoneUtilisateur> {
	/**
	 * Constructeur
	 */
	constructor(private prestationService: PrestationService,
				private toastrService: ToastrService,
				private matDialog: MatDialog,
				private translateService: TranslateService,
				private confirmService: ConfirmService) {
		super();
	}

	/**
	 * Clic sur la ZU courante
	 */
	onSelect(): void {
		//Ouverture de la boîte de dialogue pour ajouter une ZU
		this.matDialog.open(AddZuComponent, {
			width: '30%',
			data: {
				idPrestation: this.extraOptions.idPrestation,
				zu: this.data
			}
		}).afterClosed().subscribe(zu => {
			if (zu.idZU) {
				//Refresh de la liste
				this.extraOptions.refreshListe();
			}
		});
	}

	/**
	 * Évènement de suppression de l'item
	 */
	public deleteZu(): void {
		//Popin de confirmation
		this.confirmService.showConfirm(this.translateService.instant('global.suppression.confirmation')).pipe(filter(isConfirmed => isConfirmed)).subscribe({
			next: () => {
				//Demande de suppression
				this.prestationService.deleteLienZuPrest(this.data.idLienZuPrest).pipe(first()).subscribe({
					next: result => {
						//En cas de succès
						if (result.codeErreur == TypeCodeErreur.NO_ERROR) {
							//Message de succès
							this.toastrService.success(this.translateService.instant('global.success.suppression'));
						} else {
							//Sinon, message d'erreur
							this.toastrService.error(this.translateService.instant('global.errors.suppression'));
						}

						//Refresh de la liste
						this.extraOptions.refreshListe();
					},
					error: () => {
						//Message d'erreur
						this.toastrService.error(this.translateService.instant('global.errors.suppression'));
					}
				});
			}
		});
	}
}
